import { AppNS } from 'app';
import ChipList, { ChipsListItem } from 'app/ui_v2/components/chip-list/ChipList';
import { unescape } from 'lodash-es';
import { useNavigate } from 'react-router-dom';

import { Box } from '@mui/material';

export interface InspectorProps {
  item: AppNS.JobEventReport;
}

const INSPECTOR_CERTIFICATIONS: ChipsListItem[] = [
  {
    id: '1',
    name: 'QA/QC',
    tooltip: 'QA/QC Report',
  },
];

export default function Inspector(props: InspectorProps) {
  const { item } = props;

  const navigate = useNavigate();
  const link = `/backoffice/agency/inspector/${item?.qaReport?.inspectorProfileId}/metrics/qa-report/${item?.qaReport?.id}`;

  return (
    <>
      {item.inspector && <>{unescape(item.inspector.fullName)}</>}
      {item?.qaReport && (
        <Box my={-2}>
          <ChipList
            list={INSPECTOR_CERTIFICATIONS}
            isClickable={true}
            classNames="outlined-gray"
            onClick={() => {
              navigate(link);
            }}
          />
        </Box>
      )}
    </>
  );
}
